module.exports = __webpack_public_path__ + "static/resume-1ef46af1f5e03ad8f1cfae75a633a0a7.pdf";